/**
 * Per-product enquiry only — multi-item quote cart retired.
 * Keeps a minimal BP namespace + variant/configurator helpers used by PDP.
 */
(() => {
  const BP = (window.BP = window.BP || {});

  BP.toast = BP.toast || function toast(message) {
    if (!message) return;
    let el = document.querySelector('[data-bp-toast]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-bp-toast', '');
      el.setAttribute('role', 'status');
      el.style.cssText =
        'position:fixed;bottom:1.25rem;left:50%;transform:translateX(-50%);z-index:2000;padding:0.75rem 1.1rem;background:var(--color-navy,#0B1E3C);color:#fff;font-size:12px;letter-spacing:0.04em;text-transform:uppercase;opacity:0;transition:opacity .2s ease;pointer-events:none;';
      document.body.appendChild(el);
    }
    el.textContent = message;
    requestAnimationFrame(() => {
      el.style.opacity = '1';
    });
    clearTimeout(el._t);
    el._t = setTimeout(() => {
      el.style.opacity = '0';
    }, 2200);
  };

  /* Variant selector sync for configurator + price on product forms */
  document.addEventListener('change', (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    if (!e.target.matches('[data-option-index], [name="id"]')) return;

    const optionSelects = [...form.querySelectorAll('[data-option-index]')].sort(
      (a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex)
    );
    const idSelect = form.querySelector('select[name="id"], [name="id"]');
    if (!idSelect) return;

    if (optionSelects.length && idSelect.tagName === 'SELECT') {
      const selected = optionSelects.map((s) => s.value);
      const match = [...idSelect.options].find((opt) => {
        try {
          const opts = JSON.parse(opt.dataset.options || '[]');
          return opts.length === selected.length && opts.every((v, i) => v === selected[i]);
        } catch (err) {
          return false;
        }
      });
      if (match) idSelect.value = match.value;
    }

    const option = idSelect.tagName === 'SELECT' ? idSelect.options[idSelect.selectedIndex] : idSelect;
    if (!option) return;

    form.dataset.variantBound = 'true';

    const priceWrap = form.querySelector('[data-product-price-wrap]');
    const priceEl = form.querySelector('[data-product-price]');
    if (priceWrap && option.dataset.showPrice === 'true') {
      priceWrap.hidden = false;
      /* Keep “Starting from” on product min — don’t swap to variant price */
      const keepsFromLabel = priceWrap.querySelector('.product-main__price-label, .price__from');
      if (priceEl && option.dataset.priceFormatted && !keepsFromLabel) {
        priceEl.textContent = option.dataset.priceFormatted;
      }
    } else if (priceWrap && option.dataset.showPrice === 'false') {
      priceWrap.hidden = true;
    }

    const skuInput = form.querySelector('input[name="contact[sku]"]');
    if (skuInput && option.dataset.sku) skuInput.value = option.dataset.sku;

    const productUrl = form.getAttribute('data-product-configurator-url') || '';
    const configuratorUrl = (option.dataset.configuratorUrl || productUrl || '').trim();
    const getLeadRaw = option.dataset.configuratorGetLead;
    const configuratorGetLead = getLeadRaw !== 'false';
    const ctaWrap = form.querySelector('[data-configurator-cta-wrap]');
    const priceNote = form.querySelector('[data-configurator-price-note]');
    if (ctaWrap) ctaWrap.hidden = !configuratorUrl;
    if (priceNote) priceNote.hidden = !configuratorUrl;

    document.dispatchEvent(
      new CustomEvent('bp:variant:change', {
        detail: {
          variantId: option.value || idSelect.value,
          configuratorUrl,
          configuratorGetLead,
          form,
        },
      })
    );
  });
})();
